// :: User Store
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";
import { PeopleEvent } from "@/vue-core/models/PeopleEvent.model";
import { ParticipantUser } from "@/models/events/users/ParticipantUser.model";
import { BillingParticipant } from "@/vue-core/models/Billing.model";

// :: State
const state: {
  program: [];
  status: boolean;
  data: any;
  logged: boolean;
  completeRegister: boolean;
  eventData: PeopleEvent | null;
  participantData: any;
  participantGeneralData: ParticipantUser | null;
  currentEventID: string | null;
  reservationRooms: any;
  courses: [];
  statusPaid: boolean;
  activateCardRegister: boolean;
  billingData: BillingParticipant | null;
  bookings: [];
  billings: [];
} = {
  program: [],
  status: false,
  data: {},
  logged: false,
  completeRegister: false,
  participantData: null,
  participantGeneralData: null,
  eventData: null,
  currentEventID: null,
  reservationRooms: {},
  courses: [],
  statusPaid: false,
  billingData: null,
  activateCardRegister: false,
  bookings: [],
  billings: [],
};

export default {
  namespaced: true,
  name: "user",
  state,
  getters,
  mutations,
  actions,
};
